import React from 'react';
import css from './FeaturesSection.module.css';
import planningPortalLogo from '../../../../assets/PPLogo_Black.svg';
import featureImg from '../../../../assets/Leadflow-feature-page.png';
import livePlanningIcon from '../../../../assets/Live-planning-logo.svg';
import filterIcon from '../../../../assets/Filter-by-location-logo.svg';
import identifyIcon from '../../../../assets/Identify-logo.svg';
import outreachIcon from '../../../../assets/Start-outreach-logo.svg';

const features = [
  { icon: livePlanningIcon, title: 'Live planning leads dashboard' },
  { icon: filterIcon, title: 'Filter by location, project type & sector' },
  { icon: identifyIcon, title: 'Identify decision-makers early' },
  { icon: outreachIcon, title: 'Start outreach immediately' },
];

const FeaturesSection = () => {
  return (
    <section className={css.section}>
      <div className={css.inner}>

        {/* Data provided by */}
        <div className={css.dataProvider}>
          <span className={css.dataText}>Data provided by</span>
          <img src={planningPortalLogo} alt="Planning Portal" className={css.ppLogo} />
        </div>

        <h2 className={css.heading}>What you'll see inside LeadFlow</h2>

        {/* Feature Icons Row */}
        <div className={css.featuresGrid}>
          {features.map((f, i) => (
            <div key={i} className={css.featureCard}>
              <div className={css.iconBox}>
                <img src={f.icon} alt={f.title} className={css.icon} />
              </div>
              <p className={css.featureTitle}>{f.title}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesSection;
